import { faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function forceElement() {
    return (
        <div data-cy="historic-icon-forceDisplay">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.forceElement" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faLock} size="lg" style={{ color: 'orange' }} />
            </Whisper>
        </div>
    );
}
